export const COMPONENT_NAME = 'consent-banner';
